// JsFromRoutes CacheKey cc0cb120c7f54691e71f0c6beff9d33b
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  show: /* #__PURE__ */ definePathHelper('get', '/:org_nano_id/setup'),
}
